/** fake group id for expanding / folding project groups */
export const UNGROUPED_GROUP_ID = Symbol();
